<owc-header class="owc--main-home-header" [class.loading]="isAdding">
  <owc-header-row elevation variant="top-primary" class="header-first-row">
    <owc-hyperlink
      [href]="'https://diagnostics.roche.com/'"
      title="Roche Diagnostics"
      target="_blank"
      style="color: #fff;"
    >
      Roche Diagnostics
    </owc-hyperlink>

    <span class="flex-spacer"></span>

    <div class="settings" style="display: flex;align-items: center;">
      <div *ngIf="profileData" class="user" title="User Settings">
        <div id="menu-trigger" style="display: flex; gap: 10px;">
          <owc-icon name="user"></owc-icon>
          <div>{{ profileData.name }}</div>
        </div>

        <div style="display: flex;gap: 10px;align-items: center;">
          <owc-menu anchor="menu-trigger" position="bottom" class="profile-menu">
            <div class="profile-menu-top" style="display: flex;">
              <owc-avatar
                style="
                  background-color: var(
                    --one-color-interaction-default-brand-base
                  );
                  color: var(--one-color-interaction-default-base);
                  display: flex;
                  align-items: baseline;
                "
              >
                <owc-typography
                  variant="title5"
                  class="typography user-initial"
                  >{{ profileData.initials }}</owc-typography
                >
              </owc-avatar>
              <div class="user-details" style="display: flex;">
                <owc-typography variant="subtitle2" class="typography">
                  {{ profileData.name }}
                </owc-typography>
                <owc-typography
                  variant="body2"
                  class="typography user-email"
                  [title]="profileData.email"
                >
                  {{ profileData.email }}
                </owc-typography>
              </div>
            </div>
            <owc-divider></owc-divider>
            <button class="profile-menu-bottom" (click)="logout()">
              <owc-icon name="standby">standby</owc-icon>
              <owc-typography variant="body1"> Logout </owc-typography>
            </button>
            <owc-divider></owc-divider>
          </owc-menu>
        </div>
      </div>

      <div title="Country/Language" style="display: flex;">
        <owc-icon name="globe"></owc-icon>
        <div>Global/EN</div>
      </div>
    </div>
  </owc-header-row>

  <owc-header-row
    seperator
    elevated
    [variant]="'primary'"
    class="header-second-row"
  >
    <div style="display:flex">
      <owc-hyperlink [href]="'/'" title="Product and Safety Care" target="_self">
        <img
          alt="eService Logo"
          class="app-logo"
          src="assets/module_product-and-safety-care_default_without-background_512px.svg"
        />
      </owc-hyperlink>
      <div class="app-title">QN/SBN</div>
      
      <div class="custom-tabs">
        <!-- Notification -->
        <div class="mat-tab-links" (click)="toNotification()">
          <a class="mat-tab-link" 
            [class.mat-tab-label-active]="activeTab === 'notification'"
            title="Notification"
            (click)="$event.preventDefault()">Notification</a>
          <span *ngIf="activeTab === 'notification'" class="mat-ink-bar"></span>
        </div>

        <!-- Dashboard -->
        <div class="mat-tab-links" (click)="toDashboard()">
          <a class="mat-tab-link"
            [class.mat-tab-label-active]="activeTab === 'dashboard'"
            title="Dashboard"
            (click)="$event.preventDefault()">Dashboard</a>
          <span *ngIf="activeTab === 'dashboard'" class="mat-ink-bar"></span>
        </div>

        <!-- Email Delivery -->
        <div class="mat-tab-links" (click)="toEmailDelivery()">
          <a class="mat-tab-link"
            [class.mat-tab-label-active]="activeTab === 'email-delivery'"
            title="Email delivery">Email delivery</a>
          <span *ngIf="activeTab === 'email-delivery'" class="mat-ink-bar"></span>
        </div>
      </div>
     
    </div>

    <div>
      <owc-hyperlink
        [href]="'https://diagnostics.roche.com/'"
        title="Roche"
        target="_blank"
      >
        <owc-logo name="roche_blue" size="mini" title="Roche"></owc-logo>
      </owc-hyperlink>
    </div>
  </owc-header-row>
</owc-header>
